/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
import { axiosWCApiInstance } from '../Configurations/AxiosConfiguration';
import { ExpenseStatusEnum } from '../Components/Expense/ExpenseStatus.enum';
import { ExpenseBillTypeEnum } from '../Components/Expense/BillType.enum';
import { ExpenseSourceEnum } from '../Components/Expense/ExpenseSource.enum';
import { PreCodedStatusEnum } from '../Components/Expense/PreCodedStatus.enum';
import { checkFeatureFlag } from '../../components/GlobalComponents/FeatureFlagComponent/FeatureFlag';
import { EXCLUDE_SPECIAL_PROCESSING } from '../../Admin/constants';

export const getClinicianAssignments = async (bookingId) => {
    try {
        const url = `assignments/${bookingId}`;
        const response = await axiosWCApiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getClinician = async (clinicianId) => {
    try {
        const url = `clinicians/${clinicianId}`;
        const response = await axiosWCApiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createExpense = async (expense) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses', expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updateExpense = async (key, expense) => {
    try {
        const response = await axiosWCApiInstance.put(`/expenses/${key}`, expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const patchExpenseCreditMemo = async (expenseId, creditMemoMode) => {
    try {
        const response = await axiosWCApiInstance.patch(
            `${expenseId}/CreditMemoMode`,
            creditMemoMode,
            { headers: { 'Content-Type': 'application/json' }, params: { isExpenseId: true } }
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseImageById = async (expenseId, imageId, isPrecoded) => {
    try {
        const response = await axiosWCApiInstance.get(
            `/expenses/${expenseId}/images/${imageId}?isPrecoded=${isPrecoded}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const deleteExpenseImageById = async (expenseId, imageId, isPrecoded) => {
    try {
        const response = await axiosWCApiInstance.delete(
            `/expenses/${expenseId}/images/${imageId}?isPrecoded=${isPrecoded}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseById = async (expenseId, getNewVersion = false) => {
    try {
        const response = await axiosWCApiInstance.get(
            `/expenses/${expenseId}?getNewVersion=${getNewVersion}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getVaultExpensesById = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.get(`/expenses/vault/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const regenerateVaultPdf = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.post(`/vault/regenerate-pdf/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenses = async () => {
    try {
        const response = await axiosWCApiInstance.get('/administration/expenses');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getPendingCCExpenseById = async (expenseId) => {
    try {
        const response = await axiosWCApiInstance.get(`/expenses/precoded/${expenseId}`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createPendingCCExpense = async (expense) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses/precoded', expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const updatePendingCCExpense = async (key, expense) => {
    try {
        const response = await axiosWCApiInstance.put(`/expenses/precoded/${key}`, expense);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createExpenseImage = async (imgData) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses/images', imgData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const postImageForOCR = async (img, documentType) => {
    try {
        const form = new FormData();
        form.append('documentData', img);

        const response = await axiosWCApiInstance.post(`/ocr?documentType=${documentType}`, form, {
            timeout: 20000,
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const uploadExpensesFile = async (formData) => {
    try {
        const response = await axiosWCApiInstance.post('/expenses/upload', formData);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getAllCreditCards = async (filterByUser = false) => {
    try {
        const url = filterByUser
            ? '/administration/CreditCards?filterByUser=true'
            : '/administration/CreditCards';
        const response = await axiosWCApiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getStatusesAllowed = async (expClass, expenseId) => {
    try {
        // Build the query string
        let url = `/expenses/statuses?expClass=${expClass}`;
        if (expenseId !== undefined && expenseId !== null) {
            url += `&expenseId=${expenseId}`;
        }

        const response = await axiosWCApiInstance.get(url);
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getNeedsReviewReasons = async () => {
    try {
        const response = await axiosWCApiInstance.get('/expenses/errorCodes');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseCategories = async (expenseTypeSelection) => {
    try {
        let aExpenseTypeSelection = expenseTypeSelection;
        if (!aExpenseTypeSelection) {
            aExpenseTypeSelection = 'All';
        }
        const response = await axiosWCApiInstance.get(
            `expenseTypes?expenseTypeSelection=${aExpenseTypeSelection}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const searchVendors = async (searchString) => {
    try {
        const url = `vendors/search/${searchString}`;
        const response = await axiosWCApiInstance.get(url, {
            params: { _: Date.now() },
        });
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const refreshVendors = async () => {
    try {
        const url = `refresh-vendors`;
        const response = await axiosWCApiInstance.get(url);

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

const getKeyFromValueStatus = (value) => {
    for (const index in ExpenseStatusEnum) {
        const statusEnum = ExpenseStatusEnum[index].UI;
        if (statusEnum === value) {
            return ExpenseStatusEnum[index].value;
        }
    }
    // If nothing is found in ExpenseStatusEnum, check PreCodedStatusEnum
    for (const index in PreCodedStatusEnum) {
        const statusEnum = PreCodedStatusEnum[index].UI;
        if (statusEnum === value) {
            return PreCodedStatusEnum[index].value;
        }
    }
};

const getKeyFromValue = (value, type) => {
    // const noSpace = value.replace(' ', '');
    for (const index in type) {
        const statusEnum = type[index];
        if (statusEnum === value) {
            return index;
        }
    }
};

// Maps the Flags filter UI labels to the API's Flags query parameter values
const FLAG_FILTER_UI_TO_API = {
    'High Priority': 'HighPriority',
    'Invoice Priority': 'InvoicePriority',
};

/**
 * Special Processing and Exclude Special Processing cannot be sent together
 * (the API returns 400 if both are present).
 *
 * Conflict handling matches Timesheet Management / Processed Timesheets:
 * - UI: selecting Exclude clears include values, and selecting any include value
 *   clears Exclude (see specialProcessingFilterOptions).
 * - API: if Exclude is selected, send only ExcludeSpecialProcessing=true and omit
 *   SpecialProcessing include params, even if both are present in the request.
 */
export const formatSpecialProcessingQueryParams = (specialProcessing = []) => {
    const selected = specialProcessing ?? [];
    if (selected.includes(EXCLUDE_SPECIAL_PROCESSING)) {
        return `&${EXCLUDE_SPECIAL_PROCESSING}=true`;
    }

    return selected
        .filter((value) => value !== EXCLUDE_SPECIAL_PROCESSING)
        .map((sp) => `&SpecialProcessing=${sp}`)
        .join('');
};

const getUrlParams = async ({
    offset,
    sortBy,
    sortDirection,
    limit,
    statuses,
    divisions,
    specialProcessing,
    transactionStartDate,
    transactionEndDate,
    expenseTypes,
    sources,
    needsReviewReasons,
    hasReceipt,
    billTypes,
    startStartDate,
    startEndDate,
    endStartDate,
    endEndDate,
    postStartDate,
    postEndDate,
    periodEndStart,
    periodEndEnd,
    payDateStart,
    payDateEnd,
    submittedStartDate,
    submittedEndDate,
    merchantStates,
    importedStart,
    importedEnd,
    search,
    searchKey,
    expenseClass,
    creditCardList,
    hasAttachments,
    flags,
}) => {
    const offsetParam = `Offset=${offset}`;
    const expenseClassParam = expenseClass ? `&ExpenseClass=${expenseClass}` : '';
    const pageSizeParam = `&PageSize=${limit}`;
    const statusParams = statuses
        ?.map((status) => `&Statuses=${getKeyFromValueStatus(status)}`)
        .join('');
    const divisionParams = divisions?.map((division) => `&Divisions=${division}`).join('');
    const specialProcessingParams = formatSpecialProcessingQueryParams(specialProcessing);
    const expenseTypeParams = expenseTypes
        ?.map((expenseType) => `&ExpenseType=${expenseType}`)
        .join('');

    let sourcesToMap = sources;
    const isNCREFFEnabled = await checkFeatureFlag(
        'NonClinicianReimbursementExpenseFeatures',
        false
    );

    if (!isNCREFFEnabled && sourcesToMap.length === 0) {
        sourcesToMap = ['Reimbursement (Associate)', 'Reimbursement (Clinician)'];
    }

    const sourceParams = sourcesToMap
        ?.map((source) => `&Source=${getKeyFromValue(source, ExpenseSourceEnum)}`)
        .join('');
    const needsReviewParams = needsReviewReasons
        ?.map((reason) => `&NeedsReviewReason=${reason.toUpperCase().replace(/ /g, '_')}`)
        .join('');

    const hasReceiptValue =
        hasReceipt?.includes('Yes') && !hasReceipt.includes('No')
            ? '1'
            : hasReceipt?.includes('No') && !hasReceipt.includes('Yes')
            ? '0'
            : null;
    const hasReceiptParam = hasReceiptValue ? `&HasReceipt=${hasReceiptValue}` : '';

    const hasAttachmentsValue =
        hasAttachments?.includes('Yes') && !hasAttachments.includes('No')
            ? '1'
            : hasAttachments?.includes('No') && !hasAttachments.includes('Yes')
            ? '0'
            : null;
    const hasAttachmentsParam = hasAttachmentsValue ? `&HasAttachments=${hasAttachmentsValue}` : '';

    const billTypeParams = billTypes
        ?.map((billType) => `&BillType=${getKeyFromValue(billType, ExpenseBillTypeEnum)}`)
        .join('');
    const merchantStateParams = merchantStates
        ?.map((merchantState) => `&MerchantState=${merchantState}`)
        .join('');
    const sortParams = sortBy ? `&OrderBy=${sortBy}&Dir=${sortDirection}` : '';
    const transactionDateStartParam = transactionStartDate
        ? `&TransactionDateStart=${transactionStartDate}`
        : '';
    const transactionDateEndParam = transactionEndDate
        ? `&TransactionDateEnd=${transactionEndDate}`
        : '';
    const startDateStartParam = startStartDate ? `&StartDateStart=${startStartDate}` : '';
    const startDateEndParam = startEndDate ? `&StartDateEnd=${startEndDate}` : '';
    const endDateStartParam = endStartDate ? `&EndDateStart=${endStartDate}` : '';
    const endDateEndParam = endEndDate ? `&EndDateEnd=${endEndDate}` : '';
    const postDateStartParam = postStartDate ? `&PostDateStart=${postStartDate}` : '';
    const postDateEndParam = postEndDate ? `&PostDateEnd=${postEndDate}` : '';
    const payDateStartParam = payDateStart ? `&PayDateStart=${payDateStart}` : '';
    const payDateEndParam = payDateEnd ? `&PayDateEnd=${payDateEnd}` : '';
    const periodEndDateStartParam = periodEndStart ? `&PeriodEndDateStart=${periodEndStart}` : '';
    const periodEndDateEndParam = periodEndEnd ? `&PeriodEndDateEnd=${periodEndEnd}` : '';
    const importedStartParam = importedStart ? `&ImportedDateStart=${importedStart}` : '';
    const importedEndParam = importedEnd ? `&ImportedDateEnd=${importedEnd}` : '';
    const submittedDateStartParam = submittedStartDate
        ? `&SubmittedDateStart=${submittedStartDate}`
        : '';
    const submittedDateEndParam = submittedEndDate ? `&SubmittedDateEnd=${submittedEndDate}` : '';
    let searchColumns;
    const hasSearch = !!searchKey;
    if (hasSearch) {
        const isSearchKeyArray = Array.isArray(searchKey.value);
        searchColumns = isSearchKeyArray
            ? searchKey.value.map((key) => `&SearchColumns=${key}`).join('')
            : `&SearchColumns=${searchKey.value}`;
    }
    const searchParams = search ? `&SearchWord=${search}${searchColumns}` : '';
    const creditCardParams = creditCardList
        ?.map((creditCardId) => `&CreditCardIdList=${creditCardId}`)
        .join('');
    const flagsParams = flags
        ?.map((flag) => `&Flags=${FLAG_FILTER_UI_TO_API[flag] || flag}`)
        .join('');

    return {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        specialProcessingParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        hasReceiptParam,
        billTypeParams,
        merchantStateParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        importedStartParam,
        importedEndParam,
        searchParams,
        expenseClassParam,
        creditCardParams,
        hasAttachmentsParam,
        flagsParams,
    };
};

export const getExpensesCSVWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        specialProcessingParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        billTypeParams,
        merchantStateParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
        flagsParams,
    } = await getUrlParams(request);

    const url = `administration/expenses/csv?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        specialProcessingParams ? `${specialProcessingParams}` : ''
    }${expenseTypeParams ? `${expenseTypeParams}` : ''}${sourceParams ? `${sourceParams}` : ''}${
        needsReviewParams ? `${needsReviewParams}` : ''
    }${billTypeParams ? `${billTypeParams}` : ''}${
        merchantStateParams ? `${merchantStateParams}` : ''
    }${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${
        postDateStartParam ? `${postDateStartParam}` : ''
    }${postDateEndParam ? `${postDateEndParam}` : ''}${
        periodEndDateStartParam ? `${periodEndDateStartParam}` : ''
    }${payDateStartParam ? `${payDateStartParam}` : ''}${
        payDateEndParam ? `${payDateEndParam}` : ''
    }${periodEndDateEndParam ? `${periodEndDateEndParam}` : ''}${
        submittedDateStartParam ? `${submittedDateStartParam}` : ''
    }${submittedDateEndParam ? `${submittedDateEndParam}` : ''}${
        searchParams ? `${searchParams}` : ''
    }${expenseClassParam ? `${expenseClassParam}` : ''}${flagsParams ? `${flagsParams}` : ''}`;

    const response = await axiosWCApiInstance
        .get(url.endsWith('&') ? url.slice(0, -1) : url, {
            responseType: 'blob', // Important: Ensures the response is a Blob
        })
        .catch(async (error) => {
            if (error instanceof Blob && error.type) {
                const text = await error.text();
                const json = JSON.parse(text);
                if (json === 'No expense data found.') {
                    const errorResponse = {
                        status: 404,
                        message: json,
                        data: null,
                    };
                    return errorResponse;
                }
            }
            throw error;
        });
    return response;
};

export const getVaultExpensesCSVWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        specialProcessingParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        hasReceiptParam,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
        importedStartParam,
        importedEndParam,
        flagsParams,
    } = await getUrlParams(request);

    const url = `administration/expenses/vault/csv?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        specialProcessingParams ? `${specialProcessingParams}` : ''
    }${expenseTypeParams ? `${expenseTypeParams}` : ''}${sourceParams ? `${sourceParams}` : ''}${
        needsReviewParams ? `${needsReviewParams}` : ''
    }${hasReceiptParam ? `${hasReceiptParam}` : ''}${billTypeParams ? `${billTypeParams}` : ''}${
        sortParams ? `${sortParams}` : ''
    }${transactionDateStartParam ? `${transactionDateStartParam}` : ''}${
        transactionDateEndParam ? `${transactionDateEndParam}` : ''
    }${startDateStartParam ? `${startDateStartParam}` : ''}${
        startDateEndParam ? `${startDateEndParam}` : ''
    }${endDateStartParam ? `${endDateStartParam}` : ''}${
        endDateEndParam ? `${endDateEndParam}` : ''
    }${postDateStartParam ? `${postDateStartParam}` : ''}${
        postDateEndParam ? `${postDateEndParam}` : ''
    }${periodEndDateStartParam ? `${periodEndDateStartParam}` : ''}${
        payDateStartParam ? `${payDateStartParam}` : ''
    }${payDateEndParam ? `${payDateEndParam}` : ''}${
        periodEndDateEndParam ? `${periodEndDateEndParam}` : ''
    }${submittedDateStartParam ? `${submittedDateStartParam}` : ''}${
        importedStartParam ? `${importedStartParam}` : ''
    }${importedEndParam ? `${importedEndParam}` : ''}${
        submittedDateEndParam ? `${submittedDateEndParam}` : ''
    }${searchParams ? `${searchParams}` : ''}${expenseClassParam ? `${expenseClassParam}` : ''}${
        flagsParams ? `${flagsParams}` : ''
    }`;

    const response = await axiosWCApiInstance
        .get(url.endsWith('&') ? url.slice(0, -1) : url, {
            responseType: 'blob',
        })
        .catch(async (error) => {
            if (error instanceof Blob && error.type) {
                const text = await error.text();
                const normalizedMessage = text.replace(/^"|"$/g, '');

                if (
                    normalizedMessage === 'No vault expenses found matching the specified criteria.'
                ) {
                    return {
                        status: 404,
                        message: normalizedMessage,
                        data: null,
                    };
                }

                try {
                    const json = JSON.parse(text);
                    throw {
                        status: json.status ?? 500,
                        message: json.message,
                        error: json.error,
                        innerError: json.innerError,
                        stackTrace: json.stackTrace,
                        timestamp: json.timestamp,
                        requestId: json.requestId,
                    };
                } catch {
                    throw new Error(normalizedMessage || 'Failed to download Vault CSV.');
                }
            }
            throw error;
        });

    return response;
};

export const getExpensesWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        specialProcessingParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        billTypeParams,
        merchantStateParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        importedStartParam,
        importedEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
        flagsParams,
    } = await getUrlParams(request);

    const url = `administration/expenses?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        specialProcessingParams ? `${specialProcessingParams}` : ''
    }${expenseTypeParams ? `${expenseTypeParams}` : ''}${sourceParams ? `${sourceParams}` : ''}${
        needsReviewParams ? `${needsReviewParams}` : ''
    }${billTypeParams ? `${billTypeParams}` : ''}${
        merchantStateParams ? `${merchantStateParams}` : ''
    }${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${
        postDateStartParam ? `${postDateStartParam}` : ''
    }${postDateEndParam ? `${postDateEndParam}` : ''}${
        periodEndDateStartParam ? `${periodEndDateStartParam}` : ''
    }${payDateStartParam ? `${payDateStartParam}` : ''}${
        payDateEndParam ? `${payDateEndParam}` : ''
    }${periodEndDateEndParam ? `${periodEndDateEndParam}` : ''}${
        submittedDateStartParam ? `${submittedDateStartParam}` : ''
    }${importedStartParam ? `${importedStartParam}` : ''}${
        importedEndParam ? `${importedEndParam}` : ''
    }${submittedDateEndParam ? `${submittedDateEndParam}` : ''}${
        searchParams ? `${searchParams}` : ''
    }${expenseClassParam ? `${expenseClassParam}` : ''}${flagsParams ? `${flagsParams}` : ''}`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const getVaultChargesWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        specialProcessingParams,
        expenseTypeParams,
        sourceParams,
        needsReviewParams,
        hasReceiptParam,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        payDateStartParam,
        payDateEndParam,
        periodEndDateStartParam,
        periodEndDateEndParam,
        submittedDateStartParam,
        submittedDateEndParam,
        searchParams,
        expenseClassParam,
        importedStartParam,
        importedEndParam,
        flagsParams,
    } = await getUrlParams(request);

    const url = `administration/expenses/vault?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        specialProcessingParams ? `${specialProcessingParams}` : ''
    }${expenseTypeParams ? `${expenseTypeParams}` : ''}${sourceParams ? `${sourceParams}` : ''}${
        needsReviewParams ? `${needsReviewParams}` : ''
    }${hasReceiptParam ? `${hasReceiptParam}` : ''}${billTypeParams ? `${billTypeParams}` : ''}${
        sortParams ? `${sortParams}` : ''
    }${transactionDateStartParam ? `${transactionDateStartParam}` : ''}${
        transactionDateEndParam ? `${transactionDateEndParam}` : ''
    }${startDateStartParam ? `${startDateStartParam}` : ''}${
        startDateEndParam ? `${startDateEndParam}` : ''
    }${endDateStartParam ? `${endDateStartParam}` : ''}${
        endDateEndParam ? `${endDateEndParam}` : ''
    }${postDateStartParam ? `${postDateStartParam}` : ''}${
        postDateEndParam ? `${postDateEndParam}` : ''
    }${periodEndDateStartParam ? `${periodEndDateStartParam}` : ''}${
        payDateStartParam ? `${payDateStartParam}` : ''
    }${payDateEndParam ? `${payDateEndParam}` : ''}${
        periodEndDateEndParam ? `${periodEndDateEndParam}` : ''
    }${submittedDateStartParam ? `${submittedDateStartParam}` : ''}${
        importedStartParam ? `${importedStartParam}` : ''
    }${importedEndParam ? `${importedEndParam}` : ''}${
        submittedDateEndParam ? `${submittedDateEndParam}` : ''
    }${searchParams ? `${searchParams}` : ''}${expenseClassParam ? `${expenseClassParam}` : ''}${
        flagsParams ? `${flagsParams}` : ''
    }`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const getPreCodedWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        specialProcessingParams,
        expenseTypeParams,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
    } = await getUrlParams(request);

    const url = `administration/precoded?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        specialProcessingParams ? `${specialProcessingParams}` : ''
    }${expenseTypeParams ? `${expenseTypeParams}` : ''}${
        billTypeParams ? `${billTypeParams}` : ''
    }${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const getCreditCardWithFilter = async (request) => {
    const {
        offsetParam,
        pageSizeParam,
        statusParams,
        divisionParams,
        specialProcessingParams,
        expenseTypeParams,
        billTypeParams,
        sortParams,
        transactionDateStartParam,
        transactionDateEndParam,
        startDateStartParam,
        startDateEndParam,
        endDateStartParam,
        endDateEndParam,
        postDateStartParam,
        postDateEndParam,
        searchParams,
        expenseClassParam,
        creditCardParams,
        hasAttachmentsParam,
        flagsParams,
    } = await getUrlParams(request);

    const url = `administration/expenses/creditcard?${offsetParam ? `${offsetParam}` : ''}${
        pageSizeParam ? `${pageSizeParam}` : ''
    }${statusParams ? `${statusParams}` : ''}${divisionParams ? `${divisionParams}` : ''}${
        specialProcessingParams ? `${specialProcessingParams}` : ''
    }${expenseTypeParams ? `${expenseTypeParams}` : ''}${
        billTypeParams ? `${billTypeParams}` : ''
    }${sortParams ? `${sortParams}` : ''}${
        transactionDateStartParam ? `${transactionDateStartParam}` : ''
    }${transactionDateEndParam ? `${transactionDateEndParam}` : ''}${
        startDateStartParam ? `${startDateStartParam}` : ''
    }${startDateEndParam ? `${startDateEndParam}` : ''}${
        endDateStartParam ? `${endDateStartParam}` : ''
    }${endDateEndParam ? `${endDateEndParam}` : ''}${
        postDateStartParam ? `${postDateStartParam}` : ''
    }${postDateEndParam ? `${postDateEndParam}` : ''}${searchParams ? `${searchParams}` : ''}${
        expenseClassParam ? `${expenseClassParam}` : ''
    }${creditCardParams ? `${creditCardParams}` : ''}${
        hasAttachmentsParam ? `${hasAttachmentsParam}` : ''
    }${flagsParams ? `${flagsParams}` : ''}`;
    const response = await axiosWCApiInstance.get(url.endsWith('&') ? url.slice(0, -1) : url);
    return response.data;
};

export const updateHighPriority = async (key, highPriority) => {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };
        const response = await axiosWCApiInstance.put(
            `/expenses/${key}/HighPriority`,
            highPriority,
            config
        );
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseHistory = async (expenseId, isPrecoded) => {
    try {
        const response = await axiosWCApiInstance.get(
            `/expenses/${expenseId}/history?isPrecoded=${isPrecoded}`
        );
        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return [];
        }
        console.error(error);
        throw error;
    }
};

export const getExpenseAssociatedInvoices = async (expenseId) => {
    try {
        if (expenseId === null || expenseId <= 0) {
            throw new Error('Invalid expenseId parameter');
        }

        const url = `expenses/${expenseId}/associatedInvoices`;
        const response = await axiosWCApiInstance.get(url);

        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return [];
        }
        console.error(error);
        throw error;
    }
};

/**
 * Credit memo mode availability for an expense. Kept separate from getExpenseAssociatedInvoices so that
 * call's response shape stays a bare array for its existing consumers.
 * Returns null when availability cannot be determined, which callers treat as "no restriction".
 */
export const getExpenseCreditMemoAvailability = async (expenseId) => {
    try {
        if (expenseId === null || expenseId <= 0) {
            throw new Error('Invalid expenseId parameter');
        }

        const url = `expenses/${expenseId}/creditMemoAvailability`;
        const response = await axiosWCApiInstance.get(url);

        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return null;
        }
        console.error(error);
        return null;
    }
};

export const getHasUsedPartialCredit = async (expenseId) => {
    try {
        if (expenseId <= 0) {
            throw new Error('Invalid expenseId parameter');
        }

        const url = `expenses/${expenseId}/hasUsedPartialCredit`;
        const response = await axiosWCApiInstance.get(url);

        return response.data;
    } catch (error) {
        if (error.response?.status === 404) {
            return [];
        }
        console.error(error);
        throw error;
    }
};

export const getWasInvoicedExpenseSplitByWorkLocation = async (expenseId) => {
    try {
        if (!expenseId || expenseId < 0) {
            throw new Error('Invalid expenseId parameter');
        }

        const url = `invoice/expense/${expenseId}/WasSplitByWL`;
        const response = await axiosWCApiInstance.get(url);

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const getExpenseInvoiceDocuments = async ({ expenseId, includeErrored = false }) => {
    try {
        const response = await axiosWCApiInstance.get(`expenses/${expenseId}/invoiceDocuments`, {
            params: { includeErrored },
        });
        return response.data;
    } catch (error) {
        console.error(`GetExpenseInvoiceDocuments error=${error}`);
        throw error;
    }
};
